module.exports = __webpack_public_path__ + "img/delete-active.dc21fe80.png";